import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

import { currency } from 'Helpers/Formats';

import TabLabel from './TabLabel';
import { useBalanceSheetContext } from '../../BalanceSheetContext';
import BalanceSheetTabs from './Tabs';
import BalanceSheetTab from './Tab';

const styles = () => ({
  root: {},
  tabs: {},
  indicator: {},
  tabLabel: {},
});

const TAB_LABEL_MAP = {
  assets: {
    label: 'What I Own',
    tabTestSelector: 'balance-sheet-asset-tab',
    labelTestSelector: 'balance-sheet-asset-tab-label',
  },
  liabilities: {
    label: 'What I Owe',
    tabTestSelector: 'balance-sheet-liability-tab',
    labelTestSelector: 'balance-sheet-liability-tab-label',
  },
};

const BalanceSheetTabsContainer = ({
  className,
  classes,
  balanceSheetStepResource,
}) => {
  const { tabName, handleSetTabName } = useBalanceSheetContext();

  return (
    <BalanceSheetTabs
      classes={{
        root: classNames(classes.root, className),
        indicator: classes.indicator,
      }}
      value={tabName}
      onChange={(e, nextTab) => handleSetTabName(nextTab)}
      variant={'fullWidth'}
    >
      {balanceSheetStepResource.attr('tabs').resources().list().map((tabResource) => {
        return (
          <BalanceSheetTab
            classes={{
              root: classes.tab,
            }}
            key={tabResource.id()}
            label={
              <TabLabel
                className={classes.tabLabel}
                label={TAB_LABEL_MAP[tabResource.id()].label}
                total={currency(tabResource.attr('total'), true)}
                TotalTypographyProps={{
                  test: TAB_LABEL_MAP[tabResource.id()].labelTestSelector,
                }}
              />
            }
            value={tabResource.id()}
            test={TAB_LABEL_MAP[tabResource.id()].tabTestSelector}
          />
        );
      })}
    </BalanceSheetTabs>
  );
};

BalanceSheetTabsContainer.defaultProps = {
  className: '',
};

BalanceSheetTabsContainer.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  balanceSheetStepResource: PropTypes.object.isRequired,
};

export default withStyles(styles)(BalanceSheetTabsContainer);
